// ----------------------------------------------------------------------

export const varBounceOut = {
  animate: {
    opacity: [1, 1, 0],
    scale: [0.9, 1.1, 0.3],
  },
};

export const varBounceOutUp = {
  animate: {
    opacity: [1, 1, 0],
    scaleY: [0.985, 0.9, 3],
    y: [-12, 24, -720],
  },
};

export const varBounceOutDown = {
  animate: {
    opacity: [1, 1, 0],
    scaleY: [0.985, 0.9, 3],
    y: [12, -24, 720],
  },
};

export const varBounceOutLeft = {
  animate: {
    opacity: [1, 1, 0],
    scaleX: [1, 0.9, 2],
    x: [0, 24, -720],
  },
};

export const varBounceOutRight = {
  animate: {
    opacity: [1, 1, 0],
    scaleX: [1, 0.9, 2],
    x: [0, -24, 720],
  },
};
